/**
 * The customer facing event name for seasonal warehouse sale
 */ export var SEASONAL_WAREHOUSE_SALE_NAME = 'SEASONAL_WAREHOUSE_SALE_NAME';
